export class FrontendScriptPastVersion {

    constructor(public name: string, public code: string, public sortName: string = "") {
    }
    
    getSortName(): string {
        return this.sortName ?? this.name;
    }
}
